import { useAppCurrencies } from "../currencies/contexts/currency-context";

export function useAllCurrenciesContent({
	value = 0,
	currency,
}: {
	value?: number | null | undefined;
	currency?: string;
}) {
	const { useExchangedValues } = useAppCurrencies();

	return useExchangedValues(value, currency);
}
